import updateHeaderPinnedCount from "./UpdateHeaderPinnedCount";

const setPinnedJobs = (event) => {
   const pinnedJobs = JSON.parse(localStorage.getItem('pinnedJobs')) || [];
   updateHeaderPinnedCount(pinnedJobs.length);
   const pinnedJobsButtons = [...document.querySelectorAll('[data-job-id]')];
   const activeButtonClass = 'pinned-job-button--active';
   pinnedJobsButtons.forEach(pinnedJobButton => {
      const jobId = pinnedJobButton.dataset.jobId;
      if (pinnedJobs.includes(jobId)) {
         pinnedJobButton.classList.add(activeButtonClass);
      }
   });
};

export default setPinnedJobs;